<template>
  <div class="map">
    <div class="map-content">
      <el-input class="elinput" v-model="addressKeyword" @input="input" placeholder="请输入地址来直接查找相关位置"></el-input>
      <baidu-map class="bmView" :scroll-wheel-zoom="true" :center="center" :zoom="zoom" @ready="handler" @click="getLocationPoint">
        <bm-marker :position="center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
          <bm-label :content="content" :labelStyle="{color: 'red', fontSize : '14px'}" :offset="{width: -35, height: 30}"/>
        </bm-marker>
        <bm-view style="width: 100%; height:250px; flex: 1"></bm-view>
        <bm-local-search :keyword="content" :auto-viewport="true" @infohtmlset="info_htmlset" v-if="addressKeyword === ''"></bm-local-search>
        <bm-local-search :keyword="keyword" :auto-viewport="true" @infohtmlset="info_htmlset" v-else></bm-local-search>
      </baidu-map>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {
      center: {lng: 0, lat: 0},
      zoom: 15,
      addressKeyword: '',
      keyword: '',
      content: ''
    }
  },
  computed: {
    ...mapState(['lng', 'lat'])
  },
  methods: {
    ...mapMutations(['changeArgs']),
    handler: function ({ BMap, map }) {
      this.center.lng = this.lng
      this.center.lat = this.lat
      this.zoom = 15

      let _this = this // 设置一个临时变量指向vue实例，因为在百度地图回调里使用this，指向的不是vue实例
      // 用所定位的经纬度查找所在地省市街道等信息
      var point = new BMap.Point(_this.lng, _this.lat)
      var gc = new BMap.Geocoder()
      gc.getLocation(point, function (rs) {
        // console.log(rs) // 地址信息
        _this.center.lng = rs.point.lng
        _this.center.lat = rs.point.lat
        _this.zoom = 15
        if (rs.surroundingPois.length === 0) {
          _this.content = rs.business
        } else {
          for (let i = 0; i < rs.surroundingPois.length; i++) {
            _this.content = rs.surroundingPois[0].title
          }
        }
      })

      window.map = map
      window.BMap = BMap
      // 赋值，方便调用，本节被用到
      this.BMap = BMap
      this.map = map
    },
    // 点击获取位置信息
    getLocationPoint (e) {
      let _this = this // 设置一个临时变量指向vue实例，因为在百度地图回调里使用this，指向的不是vue实例
      // 用所定位的经纬度查找所在地省市街道等信息
      var point = new this.BMap.Point(e.point.lng, e.point.lat)
      var gc = new this.BMap.Geocoder()
      gc.getLocation(point, function (rs) {
        // console.log(rs) // 地址信息
        _this.center.lng = rs.point.lng
        _this.center.lat = rs.point.lat
        _this.zoom = 15
        if (rs.surroundingPois.length === 0) {
          _this.content = rs.business
        } else {
          for (let i = 0; i < rs.surroundingPois.length; i++) {
            _this.content = rs.surroundingPois[0].title
          }
        }
      })
    },
    // 选择定位
    info_htmlset (e) {
      // 向父组件传值
      let data = {
        longitude: e.point.lng,
        latitude: e.point.lat,
        positionName: e.title
      }
      this.$emit('fatherMethod', data)
    },
    // 搜索框
    input () {
      if (this.addressKeyword === '') {
        this.keyword = this.content
      } else {
        this.keyword = this.addressKeyword
      }
    }
  }
}
</script>
<style scoped>
.map {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}
.map-content {
  padding: 0 10px;
  height: 100%;
  background-color: #ffffff;
}
.elinput {
  padding: 10px 0;
}
</style>>



// WEBPACK FOOTER //
// src/components/Repair/BaiduMap.vue